export function readIsRedFlag(value: unknown): boolean {
  if (value === true || value === 1 || value === 'true') {
    return true;
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  const record = value as Record<string, unknown>;
  const raw = record.is_red_flag ?? record.isRedFlag;
  if (raw === value) {
    return false;
  }

  return readIsRedFlag(raw);
}

export function readIsSensitive(value: unknown): boolean {
  if (value === true || value === 1 || value === 'true') {
    return true;
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  const record = value as Record<string, unknown>;
  const raw = record.is_sensitive ?? record.isSensitive;
  if (raw === value) {
    return false;
  }

  return readIsSensitive(raw);
}

export function readSensitiveReason(value: unknown): string | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const record = value as Record<string, unknown>;
  const raw = record.sensitive_reason ?? record.sensitiveReason;
  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim();
  return trimmed || null;
}

export function readIsPregnant(value: unknown): boolean {
  if (value === true || value === 1 || value === 'true') {
    return true;
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  const record = value as Record<string, unknown>;
  const raw = record.is_pregnant ?? record.isPregnant;
  if (raw === value) {
    return false;
  }

  return readIsPregnant(raw);
}

export function readPregnantUntil(value: unknown): string | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const record = value as Record<string, unknown>;
  const raw = record.pregnant_until ?? record.pregnantUntil;
  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(trimmed) ? trimmed : null;
}
